// CSS
import '../sass/main.scss'

// === DYNAMIC SCRIPTS IMPORTER
// note: this file MUST be placed before WP Alpha main, otherwise scripts might load too late
import './components/dynamic-scripts-importer'

// === WP ALPHA ASSETS
import '@nematis/wp-alpha/assets/js/main'

// === LARGEUR DE LA BARRE DE DÉFILEMENT
// utilisée par helpers/_full-width.scss : les bandes pleine largeur s'arrêtent au bord de la barre (100vw la compte)
const setScrollbarWidth = () => {
  document.documentElement.style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`)
}
setScrollbarWidth()
window.addEventListener('resize', setScrollbarWidth, {
  passive: true
})
window.addEventListener('load', setScrollbarWidth) // la barre n'apparaît qu'une fois la page assez haute

// === BILLET « PROCHAIN SPECTACLE » (templates/components/billet.twig)
import './components/billet'

// === THIRD PARTY
// import './third-party/rousquille'
